import { gap, gutter, spacing } from '@lamimed/pantheon';
import styled, { css } from 'styled-components';

import { ColumnRowProps } from './';

export const ColumnRowWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;

  & > :last-child {
    flex-shrink: 0;
  }
`;

export const IconWrapper = styled.div<
  Pick<ColumnRowProps, 'marginBottom' | 'marginTop' | 'reverse'>
>`
  display: flex;
  width: 100%;
  align-items: center;

  ${gap(gutter.small)}

  ${({ marginBottom, marginTop, reverse }) => css`
    margin-bottom: ${marginBottom ? spacing[marginBottom] : spacing.none};
    margin-top: ${marginTop ? spacing[marginTop] : spacing.none};

    ${reverse &&
    css`
      flex-direction: row-reverse;
    `}
  `}
`;
